class PrintBoxApi {

  constructor(options) {

    options = options || {}
    this.printbox = options.pbxRef || {}
    this.printbox.customer = options.customer;
    this.printbox.presetNumber = options.presetNumber;
    this.printbox.folderStructure = options.folderStructure;
    this.printbox.rotate = options.rotate;
    this.printbox.editConfig = options.editConfig || {}

    //sessionId
    let sessionId = localStorage.getItem("pbxSessionId");
    sessionId = (sessionId == "~~" ? "" : sessionId) || "";

    if (sessionId == 'undefined') {
      sessionId = ""
    }

    //if there is no email..empty session
    if (!options.customer || !options.customer.email) {
      sessionId = ""
    }

    this.options = new PrintBoxImpl().options(options.projectId || "", options.familyId, sessionId)
    this.printbox.shopifyProductId = options.shopifyProductId || this.printbox.shopifyProductId
    this.util = new PrintBoxUtil()
  }

  init() {
    if (!this.printbox) {
      throw new Error("printbox core lib not set...cannot continue");
    }

    this.printbox.setEditorConfig(this.options);
    this.registerCallbacks();
  }

  registerCallbacks() {
    this.printbox.authUserRequest = this.authUserRequest.bind(this);
    this.printbox.savingFinished = this.savingFinished.bind(this);
    this.printbox.goToCartFinished = this.goToCartFinished.bind(this);
    this.printbox.beginGoToCart = this.beginGoToCart.bind(this);
  }

  authUserRequest() {

    return new Promise((resolve, reject) => {
      let sessionId = localStorage.getItem("pbxSessionId") || '~~';
      return $.ajax({
        type: 'POST',
        url: this.util.apiBase + '/printbox/sessions/' + sessionId,
        data: { customer: this.printbox.customer },
        dataType: 'json',
      }).then((res) => {

        //if anonymous request
        if (res.isAnon) {
          localStorage.removeItem('pbxSessionId');
          reject();
        }

        //store the session
        localStorage.setItem('pbxSessionId', res.session)
        resolve(res.session);
      });
    });

  }
  async beginGoToCart() {
    return new Promise((resolve, reject) => {
      this.util.generateOverlay();
      resolve(true);
    });
  }

  async savingFinished(projectId) {

  }

  validateProject(projectId) {
    return $.ajax({
      type: 'GET',
      url: this.util.apiBase + '/printbox/projects/' + projectId + '/validate',
      headers: { 'x-pbx-sessionid': localStorage.getItem('pbxSessionId') || "" },
      dataType: 'json',
    });
  }

  async goToCartFinished(projectId) {
    try {

      //get printbox project 
      let project = await this.getProject(projectId);
      let params = project.params[0];
      let variantCode = "", variantId;
      let attribs = params.attribute_values_ids;
      for (let i = 0; i < attribs.length; i++) {
        variantCode += attribs[i];
      }

      if (project.pageSettings) {
        let extraPages = params.page_count - project.pageSettings.pages_initial;
        if (extraPages > 0) {
          //the variantCode should always either be the pages_initial or the page_count, whichever is greater
          variantCode += params.page_count;
        } else {
          variantCode += params.pages_initial;
        }
      }

      if (variantCode && this.printbox.shopifyVariants) {
        variantId = this.printbox.shopifyVariants[variantCode];
      }

      let variant = {};
      if (variantId) {
        variant.id = variantId;
        variant.newlyCreated = false;
      }

      //get shopify cart items
      if (!variant.id) {
        variant = await this.getOrCreateVariant(projectId, this.printbox.shopifyProductId);
      }

      let cart = await this.getCart() || {};
      let matchingVariants = [];
      if (cart.item_count > 0) {
        matchingVariants = cart.items.filter(item => item.variant_id == variant.id)
      }
      let isNewPBXProject = cart.items.filter(v => v.properties.pbx_projectid == projectId).length == 0
      let variantChanged = false;
      //if old pbx project, but a new variant has been selected
      if (!isNewPBXProject && matchingVariants.length == 0) {

        //remove the target cart item
        let cartItemToBeRemoved = cart.items.filter(v => v.properties.pbx_projectid == projectId)[0];
        await this.updateCart(cartItemToBeRemoved.variant_id, 0);
        variantChanged = true;
      }

      //if new pbx project..or underlying variant changed, then add to cart
      if (isNewPBXProject || variantChanged) {
        await this.addToCart(projectId, variant.id);
      }

      this.util.clearOverlay();
      let reloadUrl = '/cart' + (variant.newlyCreated ? "?new__v=1" : "");
      window.location.href = reloadUrl;

    }
    catch (ex) {
      this.util.clearOverlay();
      console.log("goToCartFinished::", ex);
    }
  }

  async getCart() {
    try {
      return await this.util.xhrify('/cart.js', {}, { 'type': 'GET', dataType: 'json' })
    }
    catch (ex) {
      console.error("getCart::", ex);
    }
  }

  async addToCart(projectId, variantId) {
    try {
      let properties = await this.getProperties(projectId);
      let data = {
        items: [{
          quantity: 1,
          id: variantId,
          properties: properties
        }]
      };

      let res = await this.util.xhrify('/cart/add.js', data, { 'type': 'POST', dataType: 'json' })
      return res;
    }
    catch (ex) {
      console.log(ex);
      throw ex;
    }
  }

  async updateCart(variantId, quantity) {
    try {
      let data = {
        quantity: quantity,
        id: variantId
      };
      await this.util.xhrify('/cart/change.js', data, { 'type': 'POST', dataType: 'json' })
    }
    catch (ex) {
      console.error("updateCart", ex);
    }
  }

  //shopify
  async getOrder(orderId) {
    try {
      let url = this.util.apiBase + '/orders/' + orderId;
      return await this.util.xhrify(url, {}, { 'type': 'GET', dataType: 'json' })
    }
    catch (ex) {
      console.error("getOrder", ex);
    }
  }

  async getOrCreateVariant(pbx_projectId, shopify_productId) {
    try {
      let url = this.util.apiBase + '/common/projects/' + pbx_projectId + '/' + shopify_productId;
      return await this.util.xhrify(url, {}, { 'type': 'POST', dataType: 'json' })
    }
    catch (ex) {
      console.error("getOrCreateVariant", ex);
    }
  }

  async validateCartLineItems(mode, editConfig) {

    //hide the checkout button on checkout page 
    let btnCheckout = jQuery('input#checkout.btn');
    btnCheckout.hide();

    let cart = await this.util.xhrify('/cart.js', {}, { 'type': 'GET', dataType: 'json' });
    let isAllSynced = await this.isAllVariantsSynced(cart);
    if (!isAllSynced) {
      console.log("unsynced item found in cart");
      window.location.href = '/cart?new__v=2';
      return;
    }

    await this.validatePBXProjectsInCart(cart, editConfig);
    this.util.clearOverlay();
    if (mode == "1" || mode == "2") {
      window.location.href = '/cart';
    }
  }

  async validatePBXProjectsInCart(cart, editConfig) {

    //checkout page
    let btnCheckout = jQuery('input#checkout.btn');
    let noPrintboxProject = true;

    let items = cart.items;

    let ajaxes = [];
    let cartItems = [];

    //find out pbx projects in the cart
    for (var i = 0; i < items.length; i++) {
      let item = items[i];

      item.properties = item.properties || {};
      let pbx_projectid = item.properties.pbx_projectid;
      if (pbx_projectid) {
        noPrintboxProject = false;
        cartItems.push(item);
        ajaxes.push(printBoxApi.validateProject(pbx_projectid));
      }
    }

    //if pbx projects exist..validate each of them through pbx
    if (ajaxes.length > 0) {
      Promise.all(ajaxes).then((data) => {
        let allOk = true;
        for (var i = 0; i < cartItems.length; i++) {
          let pbxValid = data[i];
          let cartItem = cartItems[i];

          debugger;
          let liId = editConfig.containerId || 'li-item-';
          let anchorId = editConfig.anchorId || 'li-item-edit-';

          let a = jQuery('#' + liId + cartItem.variant_id + "-" + (i + 1));
          let edit = jQuery('#' + anchorId + cartItem.variant_id + "-" + (i + 1));
          let href = a.attr('href') + '&pbx_projectid=' + pbxValid.uuid;
          edit.attr('href', href);
          edit.show();

          if (!pbxValid.is_orderable) {
            jQuery('#li-row-' + cartItem.variant_id + "-" + (i + 1)).css({ 'background-color': '#ccc' });
            allOk = false;
            jQuery('#checkoutDisabledMessage').show();
          }
        }
        if (allOk || noPrintboxProject) {
          btnCheckout.show();
        }
      })
    } else {
      btnCheckout.show();
    }
  }

  async isAllVariantsSynced(cart) {
    let items = cart.items;
    let result = true;
    for (var i = 0; i < items.length; i++) {
      let item = items[i];

      //line item is not yet available
      if (!item.image && item.final_price === 0) {
        result = false;
        break;
      }
    }

    return result;
  }

  async getProperties(projectId) {
    let properties = {
      "pbx_projectid": projectId
    };

    if (this.printbox.presetNumber) {
      properties["_presetNumber"] = this.printbox.presetNumber
    }

    if (this.printbox.folderStructure) {
      properties["_folderStructure"] = this.printbox.folderStructure
    }

    if (this.printbox.rotate) {
      properties["_rotate"] = this.printbox.rotate
    }

    return properties;
  }

  async getProject(projectId) {
    try {
      let url = this.util.apiBase + '/printbox/projects/' + projectId;
      return await this.util.xhrify(url, {}, { 'type': 'GET', dataType: 'json' })
    }
    catch (ex) {
      console.error("getProject", ex);
    }
  }

  async getProjectThumbnail(projectId) {
    try {
      let url = this.util.apiBase + '/printbox/projects/' + projectId + '/thumbnail';
      return await this.util.xhrify(url, {}, { 'type': 'GET', dataType: 'json' })
    }
    catch (ex) {
      console.error("getProjectThumbnail", ex);
    }
  }

  async getOrCreateSession() {
    try {
      let sessionId = localStorage.getItem("pbxSessionId") || '~~';
      let url = this.util.apiBase + '/printbox/sessions/' + sessionId;
      let res = await this.util.xhrify(url, { customer: this.printbox.customer }, { 'type': 'POST', dataType: 'json' })
      if (!res.isAnon) {
        localStorage.setItem("pbxSessionId", res.session);
      }
      return res;
    }
    catch (ex) {
      console.error("getOrCreateSession", ex);
    }
  }

  async getSavedPBXProjects(offset, limit) {
    try {

      let p = await this.getOrCreateSession();
      offset = offset || 0;
      limit = limit || 100;
      let url = `${this.util.apiBase}/printbox/projects/all?offset=${offset}&limit=${limit}`;
      let sessionId = localStorage.getItem('pbxSessionId');
      return await this.util.xhrify(url, {}, { 'type': 'GET', dataType: 'json', 'headers': { 'x-pbx-sessionid': sessionId || "" } })
    }
    catch (ex) {
      console.error("getSavedPBXProjects", ex);
    }
  }

}